import React from "react";

export default function SectionHeader({ kicker, title, subtitle, align = "left" }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${alignClass}`}>
      {kicker && <div className="kicker mb-2">{kicker}</div>}
      <h2 className="section-title text-3xl md:text-4xl leading-tight">{title}</h2>
      <div className={`divider-gold ${align === "center" ? "mx-auto" : ""}`} />
      {subtitle && <p className="text-[var(--melopa-muted)] text-base md:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}
